/**
 * Field-level help content for Artifact forms and detail views.
 * Spec 58 Phase F.
 */

export const ARTIFACTS_FIELD_HELP = {
  kind: 'Type of artifact: Decision (approval), Plan (roadmap), Draft (document), Report (analysis), Code (implementation), Spec (design), Design (mockup), or Custom.',
  title: 'Human-readable title (e.g., "Decision: Increase position size by 10%").',
  content:
    'Full markdown content, optionally with YAML frontmatter (---\\nkind: X\\n---) at the top. Frontmatter can include version, tags, references, and custom metadata.',
  scope:
    'Where the artifact is stored: Conversation (private), Team (shared), Task (task-specific), Project (project-wide), Agent (agent-knowledge), or Org (org-wide).',
  metadata:
    'Extracted frontmatter fields (version, tags, references). Auto-populated from content; you can also edit directly in some modes.',
};
